module.exports = __webpack_public_path__ + "img/20210701_160047.c9cc4c8e.jpg";